import { ErrorContainer } from "../../components/errors/ErrorContainer";

export default function InternalServerError() {
  return (
    <ErrorContainer
      status={400}
      text="Diese Seite konnte nicht gefunden werden"
      subtext="Der Link ist eventuell korrupt oder diese Seite wurde entfernt"
    />
  );
}
